'use client';

import React from 'react';
import { Sparkles, CircleHelp } from 'lucide-react';

interface AppIconProps {
  name?: string;
  size?: number;
  className?: string;
  strokeWidth?: number;
  onClick?: () => void;
  [key: string]: any;
}

export default function AppIcon({ name = 'SparklesIcon', size = 24, className = '', strokeWidth = 2, onClick, ...props }: AppIconProps) {
  const Icon = name === 'QuestionMarkCircleIcon' ? CircleHelp : Sparkles;
  return <Icon size={size} className={className} strokeWidth={strokeWidth} onClick={onClick} {...props} />;
}
